import { render, staticRenderFns } from "./ValidatorLogo.vue?vue&type=template&id=00dcbce7&"
import script from "./ValidatorLogo.vue?vue&type=script&lang=js&"
export * from "./ValidatorLogo.vue?vue&type=script&lang=js&"
import style0 from "./ValidatorLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports